import React from "react";
import { Box, Tooltip } from "@chakra-ui/react";
import { ActionButton } from "@/js/components/Classrooms/ActionButton";
import { ChatButtonStatusIndicator } from "./ChatButtonStatusIndicator";

interface Props {
	hasUnreadMessages: boolean;
	isChatActive: boolean;
	handleClick: () => void;
	hideStatusCircle?: boolean;
	disabledChat?: boolean;
}

export function ChatButton(props: Props): JSX.Element {
	return (
		<Tooltip
			label="Chat not supported in this class"
			aria-label="Chat not supported in this class"
			placement="bottom"
			hasArrow
			isDisabled={!props.disabledChat}
		>
			<Box position={"relative"}>
				{(!props.hideStatusCircle || props.hasUnreadMessages) && !props.disabledChat && (
					<ChatButtonStatusIndicator active={props.isChatActive} hasUnreadMessages={props.hasUnreadMessages} />
				)}
				<ActionButton
					label="Chat"
					icon="fa-message-lines"
					handleClick={props.handleClick}
					disabled={props.disabledChat}
					testId="chat-button"
				/>
			</Box>
		</Tooltip>
	);
}
